// src/Pages/Usuario/Agenda/components/FechaSelector.jsx
import React from "react";

export default function FechaSelector({
  form,
  setForm,
  minDate,
  minDateForService,
  fechaError,
  primarySlot,
  setPrimarySlot,
}) {

  // Determinar fecha mínima real según el servicio
  const min = minDateForService || minDate;

  const handleChange = (e) => {
    const v = e.target.value;

    // Resetear horario seleccionado cuando cambia la fecha
    if (primarySlot) setPrimarySlot(null);

    setForm((prev) => ({
      ...prev,
      fecha: v,
    }));
  };

return (
  <div className="mb-6 w-full">
    <label className="block font-semibold text-[#00698F] mb-2 text-base sm:text-lg">
      Selecciona una fecha
    </label>

    <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4">
      {/* INPUT FECHA */}
      <input
        type="date"
        value={form.fecha || ""}
        min={min}
        onChange={handleChange}
        className="
          w-full sm:w-60 
          border border-gray-300 rounded-xl px-3 py-2 bg-white/90
          focus:ring-2 focus:ring-[#00698F] transition
          text-sm sm:text-base
        "
      />

      {/* Fecha seleccionada para pantallas chicas */}
      {form.fecha && (
        <span className="text-[#00698F]/70 text-sm sm:hidden mt-2">
          Seleccionada: {form.fecha}
        </span>
      )}
    </div>

    {fechaError && (
      <p className="text-red-500 text-sm mt-1">
        {fechaError}
      </p>
    )}
  </div>
);

}
